import React from 'react';

const SiteFooter = () => {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div>
          <p className="footer-title">HelpSoftware</p>
          <p>Soluzioni software dal 1998</p>
        </div>
        <div>
          <p>© {new Date().getFullYear()} HelpSoftware</p>
          <p>P. IVA IT12541300153</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
